module.exports = __webpack_public_path__ + "media/presentation2.979bec13.mp4";